module.exports = __webpack_public_path__ + "img/x-box-image-detail-4.61201e9a.png";